import { autoinject } from "aurelia-dependency-injection";
import { bindable } from "aurelia-templating";

//Load styles
require("./comp-desktop-filter.scss");

@autoinject
export class CompDesktopFilter {

    // Reference to the filter component html element
    public filterElement: HTMLElement;

    // Determines whether to display the filter content to the left or right side of the filter
    public filterContentPosition: 'left' | 'right' = 'left';

    // The label text of the filter
    @bindable
    public label: string = "";

    // When the filter is open
    @bindable
    public isActive: boolean;

    // The filter count (number displayed next to filter label)
    @bindable
    public count: number;

    // Determines whether to show/hide styles indicating that the filter is opened or not
    @bindable
    public showFilter: boolean;

    // Whether an expandable/dropdown filter/s are displayed
    @bindable
    public isDropdown: boolean;

    // Show the filter labels (filter label and filter count)
    @bindable
    public showFilterLabels: boolean = true;

    // Show the dropdown arrow (chevron)
    @bindable
    public showDropdownArrow: boolean = true;

    // Show the 'Cross' icon for removing the applied filters-
    @bindable
    public showRemoveDropdownFilters: boolean;

    @bindable
    public lockedFeature: boolean;

    constructor() { }

    attached() {
        //Initially re-position filter content based on window width
        this.rePositionContent();
        window.addEventListener('resize', this.rePositionContent);
    }

    detached() {
        window.removeEventListener('resize', this.rePositionContent);
    }

    // Reposition the content that is displayed when the filter is opened
    rePositionContent = () => {
        setTimeout(() => {
            if (this.filterElement) {
                //Get filter 'right' position relative to the window
                const filterElementPosX = window.innerWidth - this.filterElement.getBoundingClientRect().right;
                //If filter is close to the window's right side, display the content to the left, else right
                this.filterContentPosition = filterElementPosX < 400 ? 'left' : 'right';
            }
        }, 100);
    };

    /**
     * Filter clicked event handler
     * @param event Event
     */
    filterClickedHandler = (event: Event) => {
        event.stopPropagation();

        const customEvent = new Event('filter-clicked', { bubbles: true });
        event.target.dispatchEvent(customEvent);
    }

    /**
     * Remove filters 'X' icon clicked handler
     * @param event Event
     */
    removeFiltersClickedHandler = (event: Event) => {
        event.stopPropagation();

        const customEvent = new Event('remove-dropdown-filters-clicked', { bubbles: true });
        event.target.dispatchEvent(customEvent);
    }
}